import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { LandingPageAPIService } from 'src/services/landingpage.api.service';

import { AppDispatch } from '../store';

const initialState = {
    blogLoading: false,
    podcastLoading: false,
    blogs: [],
    podcast: []
};

export const LandingSlice = createSlice({
    name: 'landingpage',
    initialState,
    reducers: {
        blogLoadingStart: (state) => {
            state.blogLoading = true
        },
        blogLoadingEnd: (state) => {
            state.blogLoading = false
        },

        podcastLoadingStart: (state) => {
            state.podcastLoading = true
        },
        podcastLoadingEnd: (state) => {
            state.podcastLoading = false
        },
        getBlogsSuccess: (state, action: PayloadAction<any>) => {
            state.blogs = action.payload;
        },
        getPodcastSuccess: (state, action: PayloadAction<any>) => {
            state.podcast = action.payload;
        }
    }
});

// Action creators are generated for each case reducer function
export const { getBlogsSuccess, blogLoadingStart, blogLoadingEnd, getPodcastSuccess, podcastLoadingStart, podcastLoadingEnd } =
    LandingSlice.actions;

export default LandingSlice.reducer;

export const getBlog = () => async (dispatch: AppDispatch) => {
    dispatch(blogLoadingStart());
    try {
        const { status, data }: { status: number, data: any } =
            await new LandingPageAPIService().getAllBlogs({});
        if (status === 200) {
            dispatch(getBlogsSuccess(data?.data || []))
        }
    } catch (err) {
        console.log(err, 'error');
    } finally {
        dispatch(blogLoadingEnd())
    }
};

export const getPodcast = () => async (dispatch: AppDispatch) => {
    dispatch(podcastLoadingStart());
    try {
        const { status, data } : { status: number, data: any } =
            await new LandingPageAPIService().getAllPodcast({});
        if (status === 200) {
            dispatch(getPodcastSuccess(data?.data || []))
        }
    } catch (err) {
        console.log(err, 'error');
    } finally {
        dispatch(podcastLoadingEnd())
    }
};
